<template>
  <section>
    <city-list :query="query" />
  </section>
</template>

<script>
import CityList from '@/components/basic/CityList'

export default {
  name: 'Cities',
  components: {
    CityList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
